import styled from 'styled-components';
import { Image } from '@/shared/ui/image';
import { BodyTextBoldSecondary } from '@/shared/ui/typography';
import { LazyImage } from '@/shared/ui/lazy-image/lazy-image';
export const SectionContent = styled.div`
  position: absolute;
  z-index: 10;
  display: none;
  width: 100%;
  height: 100%;
  margin-top: 12px;
  margin-bottom: 4px;
`;

export const SectionTitle = styled.div`
  color: #edeff5;
  text-align: center;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 16.8px */
`;

export const DisabledOverlay = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(52, 51, 52, 0.9);

  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
  color: white;
  text-align: center;
  padding: 8px;
  cursor: not-allowed;

  & > ${BodyTextBoldSecondary} {
    margin-top: 12px;
  }

  @media (max-width: 768px) {
    & > ${BodyTextBoldSecondary} {
      margin-top: 10px;
    }
  }
  ${({ $disabledGame }) =>
    $disabledGame &&
    `
      display:flex;
    `}
`;
export const WraperImg = styled.div`
  border-radius: 50%;
  background:
    linear-gradient(180deg, rgba(22, 22, 57, 0) 0%, rgba(22, 22, 57, 0.5) 100%),
    #676767;
  padding: 10px;
  margn: auto;
`;

export const Section = styled.div`
  grid-column-end: span 1;
  grid-row-end: span 1;
  width: 100%;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  height: auto;
  aspect-ratio: 127/170;

  ${({ $hasScroll }) =>
    $hasScroll &&
    `
      @media (max-width: 768px) {
        width: 115px;
        height: 154px;
        flex-grow: 0;
        flex-shrink: 0;
      }
    `}

  ${({ $disabledGame }) =>
    !$disabledGame &&
    `
      @media (min-width: 768px) {
        &:hover {
          &:after {
            content: '';
            position: absolute;
            top: 0;
            background: url(/images/background/hover-game.svg),
              linear-gradient(90deg, #ff9500 0%, #ff5e00 100%) #ff9500;
            background-position: center center;
            animation: 10s linear 0s infinite normal none running rotate;
            inset: -50%;
            background-blend-mode: overlay;

            ${({ $status }) =>
              $status === 'new' &&
              `
                background-color: rgb(73, 165, 27);
                background-image: url(/images/background/hover-game-green.svg);
              `}

            ${({ $status }) =>
              $status === 'popular' &&
              `
                background-image: url(/images/background/hover-game-orange.svg);
                background-color: rgb(228, 137, 0);
              `}
          }

          & > ${SectionContent} {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
        }
      }

      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `}
`;

export const ImageTemplate = styled.div`
  position: absolute;
  padding: 0px 5px;
  color: var(--edeff-5, #edeff5);
  text-align: center;
  text-shadow: 0px 1px 1px rgba(18, 22, 32, 0.4);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  border-radius: 0px 0px 6px 6px;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);

  /* @media (max-width: 768px) {
    z-index: 1;
  } */

  ${({ $status }) =>
    $status === 'new' &&
    `
box-shadow: 0px 2px 2px -1px rgba(18, 22, 32, 0.24), 0px 1px 1px 0px rgba(239, 241, 243, 0.12) inset;
background: radial-gradient(50% 100% at 50% 0%, #77BF00 0%, #4EAC1E 100%);

`}

  ${({ $status }) =>
    $status === 'popular' &&
    `
box-shadow: 0px 2px 2px -1px rgba(18, 22, 32, 0.24), 0px 1px 1px 0px rgba(239, 241, 243, 0.12) inset;
background: radial-gradient(49.58% 100% at 49.58% 0%, #FDB118 0%, #EE8F00 100%);
`}
`;

export const ImageElement = styled(LazyImage)`
  padding: 1px;
  border-radius: 8px;
  object-fit: cover;
  position: relative;
  color: #fff;
  @media (max-width: 768px) {
    /* width: 127px; */
  }

  ${({ $status }) =>
    $status === 'new' &&
    `
  box-shadow: 0px 2px 12px -2px rgba(78, 172, 31, 0.40), 0px 0px 8px -2px rgba(78, 172, 31, 0.80) inset, 0px 0px 1px 1px rgba(78, 172, 31, 0.80) inset, 0px 1px 1px 0px rgba(239, 241, 243, 0.12) inset;
      `}

  ${({ $status }) =>
    $status === 'popular' &&
    `
      box-shadow: 0px 0px 8px -2px rgba(239, 143, 1, 0.80) inset, 0px 0px 1px 1px rgba(239, 143, 1, 0.80) inset, 0px 1px 1px 0px rgba(239, 241, 243, 0.12) inset, 0px 2px 12px -2px rgba(239, 143, 1, 0.40);
          `}
`;
export const SectionDescription = styled.div`
  color: #ffda44;
  text-align: center;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
`;
export const SectionButton = styled.div`
  border-radius: 8px;
  background: #edeff5;
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.2) inset;
  margin: 0 28px;
  margin-top: 14px;
  color: #161639;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 16.8px */
  text-align: center;
  padding: 12px 12px;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const GameDetailWrapper = styled.div`
  position: fixed;
  top: 0;
  z-index: 99999;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(19, 19, 21, 0.65);
  backdrop-filter: blur(18px);
  padding: 32px 24px;
`;

export const GameDetailBlock = styled.div`
  text-align: center;
  height: 100%;
  gap: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const CloseIcon = styled(Image)`
  text-align: center;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 100;
  cursor: pointer;
`;

export const ProviderImage = styled(Image)`
  margin: 0 auto;
`;

export const GameImage = styled(Image)`
  object-fit: cover;
  border-radius: 16px;
  padding: 1px;
  ${({ $status }) =>
    $status === 'popular' &&
    `
    box-shadow: 0px 0px 8px -2px rgba(239, 143, 1, 0.80) inset, 0px 0px 1px 1px rgba(239, 143, 1, 0.80) inset, 0px 1px 1px 0px rgba(239, 241, 243, 0.12) inset, 0px 2px 12px -2px rgba(239, 143, 1, 0.40);
  `}
  ${({ $status }) =>
    $status === 'new' &&
    `
  box-shadow: 0px 2px 12px -2px rgba(78, 172, 31, 0.40), 0px 0px 8px -2px rgba(78, 172, 31, 0.80) inset, 0px 0px 1px 1px rgba(78, 172, 31, 0.80) inset, 0px 1px 1px 0px rgba(239, 241, 243, 0.12) inset;
`}
`;

export const GameDetailTextBlock = styled.div`
  margin-top: 8px;
  margin-bottom: 12px;
`;

export const GameImageWrapper = styled.div`
  width: 238px;
  max-height: 320px;
  min-height: 320px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  box-shadow: 0px 0px 100px 0px #131315;
  ${({ $status }) =>
    $status === 'popular' &&
    `
    box-shadow: 0px 0px 8px -2px rgba(239, 143, 1, 0.80) inset, 0px 0px 1px 1px rgba(239, 143, 1, 0.80) inset, 0px 1px 1px 0px rgba(239, 241, 243, 0.12) inset, 0px 2px 12px -2px rgba(239, 143, 1, 0.40);
  `}
  ${({ $status }) =>
    $status === 'new' &&
    `
  box-shadow: 0px 2px 12px -2px rgba(78, 172, 31, 0.40), 0px 0px 8px -2px rgba(78, 172, 31, 0.80) inset, 0px 0px 1px 1px rgba(78, 172, 31, 0.80) inset, 0px 1px 1px 0px rgba(239, 241, 243, 0.12) inset;
`}
`;
export const GameDetailButtons = styled.div``;

export const GameDetailButtonsWrapper = styled.div`
  position: relative;
`;

export const GameDetailButton = styled.div`
  display: flex;
  height: 48px;
  padding: 12px 16px 12px 14px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  align-self: stretch;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  z-index: 1000;
  background: #625a63;
  ${({ $action }) =>
    $action === 'play' &&
    `
background: linear-gradient(89deg, #FF9500 0.66%, #FF5E00 116.39%);

margin-bottom:12px;
 
`}
`;

export const ImageBonus = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 32px;
  height: 32px;
  background-repeat: no-repeat;
  background-size: contain;
  ${({ $hasBonus }) =>
    $hasBonus &&
    `
    background-image: url(/images/icons/gift-game.svg);
  `}
`;
export const InfoPseudoButton = styled.div`
  width: 20px;
  height: 20px;
  background-image: url(/images/icons/info-empty.svg);

  &:hover {
    background-image: url(/images/icons/info-filled.svg);
  }
`;
